import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormAutomation } from "src/app/form/form-automation";
import { User } from "src/app/models/user";
import { ActionService } from "src/app/services/action.service";
import { ApplicationPool } from "src/app/services/application.pool";

@Component({
  selector: "app-password-update",
  templateUrl: "./password-update.component.html",
  styleUrls: [
    "./password-update.component.scss",
    "../login/login.component.scss",
    "../template/template.component.scss",
  ],
})
export class PasswordUpdateComponent implements OnInit {
  updateLoading = false;
  updateCompleted = false;
  FormAutomation = FormAutomation;

  constructor(
    private dataService: ActionService,
    private dataPool: ApplicationPool,
  ) {}

  ngOnInit(): void {}

  password1: string = "";
  password2: string = "";

  async submit() {
    this.updateLoading = true;
    await this.dataService.saveAuthUser(
      new User(
        this.dataPool.User.username,
        this.password1,
        this.dataPool.User.library,
        this.dataPool.User.email,
        this.dataPool.User.id,
      ),
    );
    this.updateLoading = false;
    this.updateCompleted = true;
  }

  hasSpecialCharacter() {
    return /[^a-zA-Z0-9\s]/.test(this.password1);
  }
  hasUpperCaseCharacter() {
    return /[A-Z]/.test(this.password1);
  }
}
